import { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../style/Menu.css";
import usePageSetup from "../hooks/usePageSetup";
import { fetchMenu } from "../api/menu/menu.reduxThunk";
import { getMenuText, getMenuHeading } from "../utils/menuUtils";
import MenuSection from "../components/menu/MenuSection";
import MenuDaySpecial from "../components/menu/MenuDaySpecial";
import MenuSkeleton from "../components/skeleton/MenuSkeleton";
import XoiComHeading from "../components/generics/XoiComHeading";
import AddressSession from "../session/AddressSession";
import LoadingBackdrop from "../components/skeleton/LoadingBackdrop";
import { setActiveDay } from "../api/xoicom.reducer";

function Menu() {
  usePageSetup("dark");

  const dispatch = useDispatch();
  const menu = useSelector((state) => state.reducer.menu);
  const loading = useSelector((state) => state.reducer.loading);
  const error = useSelector((state) => state.reducer.error);
  const activeDay = useSelector((state) => state.reducer.activeDay);
  const language = useSelector((state) => state.reducer.language);

  const menuText = getMenuText(language);
  const heading = getMenuHeading(activeDay, language);

  useEffect(() => {
    dispatch(setActiveDay());
    dispatch(fetchMenu());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const announcement = useSelector((state) => state.reducer.announcement);

  const featuredItems = menu.featured?.items || [];
  const featuredImage = menu.featured?.image || "";
  const menuGrouped = menu.grouped || {};

  const isMenuEmpty =
    featuredItems.length === 0 && Object.keys(menuGrouped).length === 0;
  const announcementText = announcement?.[language] || announcement?.vn || "";
  const showAnnouncement = isMenuEmpty && announcementText.trim().length > 0;

  return (
    <Fragment>
      <LoadingBackdrop open={loading} />
      <div className="menu-page">
        {/* Header */}
        <div className="menu-header">
          <XoiComHeading heading={heading} />
          <p className="body-b2 menu-subtitle">{menuText.subtitle}</p>
        </div>

        {loading ? (
          <MenuSkeleton />
        ) : error ? (
          <p className="body-b1 menu-error">{menuText.error}</p>
        ) : isMenuEmpty ? (
          showAnnouncement ? (
            <p className="body-b1 menu-announcement">{announcementText}</p>
          ) : (
            <p className="body-b1 menu-empty">{menuText.empty}</p>
          )
        ) : (
          <Fragment>
            <MenuDaySpecial
              items={featuredItems}
              imageSrc={featuredImage}
              heading={menuText.featuredHeading}
              language={language}
            />

            <MenuSection grouped={menuGrouped} language={language} />
          </Fragment>
        )}

        {/* divider */}
        <hr className="menu-divider" />

        {/* Notes */}
        <h3 className="body-b1 menu-notes-heading">{menuText.notesHeading}</h3>
        <ul className="body-b1 menu-notes-list">
          {menuText.notes.map((note) => (
            <li key={note}>{note}</li>
          ))}
        </ul>

        {/* CTA */}
      </div>
      <AddressSession mode="cta" />
    </Fragment>
  );
}

export default Menu;
